import React, { useState } from "react";
import { BsFillEyeFill } from "react-icons/bs";
import "../Signin/Signin.css";
import { Link } from "react-router-dom";

const Signin = () => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="full-sign-in">
    <div className="row m-4 signin-container">
      <div className="col-md-6">
        <img src="/pnglog.svg" alt="login" />
      </div>
      <div className="col-md-6 signin-container-col2">
        <form>
          <h4 className="text-center">Admin Login In</h4>
          <div className="mb-3">
            <label htmlFor="email" className="form-label">
              User Id
            </label>
            <input type="email" className="form-control" id="email" />
          </div>
          <div className="mb-2">
            <label htmlFor="password" className="form-label">
              Password
            </label>
            <input type={showPassword ? "text" : "password"} className="form-control" id="password" />
          </div>
          <div className="mb-3 show-pass-forgot">
            <span onClick={() => setShowPassword(prev => !prev)} style={{ cursor: "pointer" }}>
              <BsFillEyeFill className="text-danger ms-2" size={25} /> show password
            </span>
          </div>
          <Link to="/upload-flights">
          <button type="button" className="btn signinbutton">
            Login
          </button>
          </Link>
          <span className="ms-4 new-user">For Admin Only</span>
          <img src="logo2.png" className="logo-login" alt="logo"/>
        </form>
      </div>
    </div>
    </div>
  );
};

export default Signin;
